module.exports = ".containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}\n\n.input-hint {\n    font-size: 12px;\n    position: absolute;\n}\n\np.hint {\n    font-size: 12px;\n    margin: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/tanques/tanque-movimentacao-form/tanque-movimentacao-form.component.css
 ** module id = 608
 ** module chunks = 0
 **/